<template>
  <div id="container" class="store_st_list">
    <!-- Location START -->
    <!-- TODO: Should be a component -->
    <div class="location_wrap">
      <div class="location">
        <span>{{ $t('views.store.bookscategory.6637') }}</span>
        <span class="svg_next">></span>
        <span>이벤트</span>
      </div>
    </div>
    <!-- Location END -->

    <div class="section pb">
      <div class="inner">
        <DisplayCategoryBar
          :current-page-title="pageTitle"
          :categories="categories"
          :current-category="currentCategory"
          @changeMode="viewModeChange"
        />
        <div
          class="eplist item_columns_grid"
          :class="[landscape ? 'item_landscape' : 'item_image']"
        >
          <ul
            v-if="isStoreBooksLoading || getStoreBooksTotalCount > 0"
            class="item_list"
          >
            <BaseBook
              v-for="(book, idx) in getStoreBooks"
              :key="idx"
              :book="book"
              :landscape="landscape"
              :display-price="true"
            />
            <Spinner
              :active="isStoreBooksLoading"
              loader="bars"
              color="#007FA2"
              background-color="#ffffff"
              :opacity="0.7"
              :is-full-page="false"
              :width="128"
              :height="128"
            />
          </ul>
          <EmptyData v-else data-tp="책" />
          <Pagination
            v-if="getStoreBooks"
            :current-page="currentPage"
            :total-count="getStoreBooksTotalCount"
            :item-per-page="booksPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
    </div>
    <HelpDesk />
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'
import { mapGetters } from 'vuex'

import 'vue-loading-overlay/dist/vue-loading.css'
import { STORE_BOOK_GET_LIST } from '@/store/types'
import EmptyData from '../../components/common/EmptyData.vue'
import DisplayCategoryBar from '@/components/common/DisplayCategoryBar.vue'

export default {
  name: 'BooksEvent',
  components: { HelpDesk, EmptyData, DisplayCategoryBar },
  data() {
    return {
      landscape: false,
      isListMenuOpen: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      booksPerPage: 15,
      category: 'EV',
      categoryTitle: '신학기 도서 할인 이벤트',
      order: parseInt(this.$route.params.order) || 1,
      categories: [
        {
          title: `대여 할인`,
          category: 'event',
          value: 'EV'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getStoreBooks',
      'isStoreBooksLoading',
      'getStoreBooksTotalCount'
    ]),
    pageTitle() {
      return this.categoryTitle
    },
    currentCategory() {
      return 'event'
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      // For related category book list, make sure user is authenticated.
      vm.$store.dispatch(STORE_BOOK_GET_LIST, {
        category: 'EV',
        page: to?.query?.page || 1
      })
      return true
    })
  },
  mounted() {
    if (!this.getStoreBooks) {
      this.$store.dispatch(STORE_BOOK_GET_LIST, {
        category: this.category,
        page: this.currentPage
      })
    }
  },
  async beforeRouteUpdate(to, from, next) {
    this.$store.dispatch(STORE_BOOK_GET_LIST, {
      category: this.category,
      page: to?.query?.page || 1
    })
    next()
  },
  methods: {
    viewModeChange(val) {
      this.landscape = val
    },
    paginate(page) {
      this.currentPage = page

      this.$router.push({
        name: 'books_event',
        params: {
          order: this.order
        },
        query: {
          page: this.currentPage
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px;
}
.location_wrap {
  max-width: 980px;
}
.store_st_list {
  .section {
    width: 100%;
    .inner {
      padding: 48px 0px;
    }
  }
}
.eplist {
  min-height: 300px;
}
.vld-overlay.is-active {
  align-items: flex-start;
}
@media (max-width: 1024px) {
  #container {
    padding-top: 0;
  }
  .store_st_list {
    .section {
      .inner {
        padding: 24px 0px;
      }
    }
  }
}
</style>
